module.exports = __webpack_public_path__ + "img/Kretschmer2022.d4f16e60.jpg";